import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";
import { getListOfArticles } from "~/slices/ListOfArticles/fragment";
import { getTextBlock } from "~/slices/TextBlock/fragment";
import { getHeroSection } from "~/slices/HeroSection/fragment";
import { getListOfProducts } from "~/slices/ListOfProducts/fragment";
import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { PLP_BANNER_FRAGMENT } from "~/components/product-tile/ProductTileImageBanner";
import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Product_list_page";

const PLP_QUERY = gql`
  query AllProductListPages($uid: String!, $lazy: Boolean!,  $lang: String = "en-in") {
    ${PAGE_TYPE}:product_list_page(uid: $uid, lang: $lang) {
      collection
      title
      plp_banner_link {
      ...PLPBabnner
      }
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices: body {
        ...${PAGE_TYPE}_hero_section
        ...${PAGE_TYPE}_list_of_products
        ...${PAGE_TYPE}_list_of_articles
        ...${PAGE_TYPE}_text_block
        ...${PAGE_TYPE}_product_catalogue_v2
      }
    }
  }
  ${getListOfArticles(PAGE_TYPE)}
  ${getTextBlock(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${getHeroSection(PAGE_TYPE)}
  ${getListOfProducts(PAGE_TYPE)}
  ${getProductCatalogueV2(PAGE_TYPE)}
  ${documentLink}
  ${externalLink}
  ${PLP_BANNER_FRAGMENT}
`;

export { PAGE_TYPE, PLP_QUERY };
